export const GET_ALL_JOB_OFFERS_MATCHES_REQUEST = 'GET_ALL_JOB_OFFERS_MATCHES_REQUEST';
export const GET_ALL_JOB_OFFERS_MATCHES_SUCCESS = 'GET_ALL_JOB_OFFERS_MATCHES_SUCCESS';
export const GET_ALL_JOB_OFFERS_MATCHES_FAILURE = 'GET_ALL_JOB_OFFERS_MATCHES_FAILURE';

export const MARK_JOB_OFFERS_AS_VIEWED_SUCCESS = 'MARK_JOB_OFFERS_AS_VIEWED_SUCCESS';
export const RESET_ALL_JOB_OFFERS_MATCHES_SUCCESS = 'RESET_ALL_JOB_OFFERS_MATCHES_SUCCESS';

export const CHANGE_MATCHED_FILTERS_SUCCESS = 'CHANGE_MATCHED_FILTERS_SUCCESS';
